import { ProtocolName } from '../constants/protocolNames';

const oneInchRouteSteps = (protocols: any) => {
  const total: number[] = [];
  protocols.forEach((e: any) => total.push(e.length));
  return total.reduce((p, c) => p + c, 0) || 0;
};

const totalRouteSteps = (protocols: any, method: string) => {
  if (!protocols || !protocols.length) return 0;

  const route: { [protocolName: string]: any } = {
    [ProtocolName.ONE_INCH]: oneInchRouteSteps(protocols),
  };

  return route[method];
};

export { totalRouteSteps };
